import { render, staticRenderFns } from "./CourseAssessmentForm.vue?vue&type=template&id=5c882672"
import script from "./CourseAssessmentForm.vue?vue&type=script&lang=js"
export * from "./CourseAssessmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports